import { basicApi } from '../utils/api';

export interface SmsTemplate {
  id: number;
  name: string;
  content: string;
  imageId?: string;
  mmsSubject?: string;
  placeholderNames: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface SmsTemplatePage {
  content: SmsTemplate[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface SmsTemplateBody {
  name: string;
  content: string;
  imageId?: string;
  mmsSubject?: string;
}

const path = '/solapi/sms-templates';

export const listSmsTemplates = async (params: { pg: number; limit: number; name?: string }) =>
  (await basicApi.get<SmsTemplatePage>(path, { params })).data;

export const getSmsTemplate = async (id: number) =>
  (await basicApi.get<SmsTemplate>(`${path}/${id}`)).data;

export const createSmsTemplate = async (body: SmsTemplateBody) =>
  (await basicApi.post<SmsTemplate>(path, body)).data;

export const updateSmsTemplate = async (id: number, body: SmsTemplateBody) =>
  (await basicApi.put<SmsTemplate>(`${path}/${id}`, body)).data;

export const patchSmsTemplateMms = async (id: number, body: { imageId: string | null; mmsSubject?: string }) =>
  (await basicApi.patch<SmsTemplate>(`${path}/${id}/mms`, body)).data;

export const deleteSmsTemplate = async (id: number) =>
  (await basicApi.delete(`${path}/${id}`)).data;

